export const iconFontAwesomeMapsBed = (
	<i className="fa-solid fa-bed"></i>
);
